// This file is stored in this repository but it will be executed in GTM
// To deploy this file to GTM we copy the content here into a GTM snippet
// For better source control, always merge any change to master before deploying to GTM
// More at: https://shippo.atlassian.net/wiki/spaces/TA/pages/931365076/Tech+Design+Marketing+source+tracking+during+registration

// This file needs to be written in vanilla JS and support all browsers

var COOKIE_NAME = 'shippoUTM';
var COOKIE_EXPIRES_IN_DAYS = 60;
var SUBDOMAIN_WHITELIST = ['lets', 'get', 'track'];

function isURLSupported() {
  // Taken from https://github.com/lifaon74/url-polyfill/blob/75c2deb52c40f252bd6cc75b4e2aaf0ead837a11/url-polyfill.js#L264
  try {
    var u = new global.URL('b', 'http://a');
    u.pathname = 'c d';
    return u.href === 'http://a/c%20d' && u.searchParams;
  } catch (e) {
    return false;
  }
}

function getQueryString() {
  var keyValuePairs = window.location.search.slice(1).split('&');
  var queryString = {};

  keyValuePairs.forEach(function (pair) {
    pair = pair.split('=');

    if (pair.length && pair.length === 2) {
      queryString[pair[0]] = decodeURIComponent(pair[1] || '');
    }
  });

  return queryString;
}

function getCookie(cookieName) {
  var name = cookieName + '=';
  var cookieArray = document.cookie.split(';');
  var cookieString = null;

  cookieArray.forEach(function (cookie) {
    cookie = cookie.replace(/^\s+|\s+$/g, '');

    if (cookie.indexOf(name) > -1) {
      cookieString = cookie.substring(name.length, cookie.length);
    }
  });

  if (cookieString !== null) {
    try {
      return JSON.parse(decodeURIComponent(cookieString));
    } catch (e) {
      return {};
    }
  }

  return {};
}

function setCookie(cookie, value, expires) {
  var parsedCurrentURL = parseURL(window.location.href);
  if (typeof expires === 'undefined') {
    expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_EXPIRES_IN_DAYS);
  }
  var cookieString =
    cookie +
    '=' +
    value +
    '; domain=' +
    parsedCurrentURL.domain +
    '.com; path=/; expires=' +
    expires.toUTCString();
  document.cookie = cookieString;
}

function arrayIntersects(firstArray, secondArray) {
  return secondArray.some(function (v) {
    return firstArray.indexOf(v) >= 0;
  });
}

function getReferrerCodeFromQS(QS) {
  return QS.rsCode || QS.gclid || QS.msclkid || QS.sh_cl || null;
}

function parseURL(url) {
  var hostname = '';
  var parsedURL = {};

  // URL API is not supported in IE
  if (isURLSupported()) {
    var urlObject = new URL(url);
    hostname = urlObject.hostname;
  } else {
    // Fallback only for IE
    var a = document.createElement('a');
    a.href = url;
    hostname = a.hostname;
  }

  // Hostname will always be subdomain.domain.tld or domain.tld
  var splitHostname = hostname.replace('www.', '').split('.');
  if (splitHostname.length === 3) {
    parsedURL.subdomain = splitHostname[0];
    parsedURL.domain = splitHostname[1];
  } else {
    parsedURL.subdomain = null;
    parsedURL.domain = splitHostname[0];
  }

  return parsedURL;
}

function isOffDomain(domain) {
  var parsedCurrentURL = parseURL(window.location.href);

  return domain !== parsedCurrentURL.domain;
}

function getUpdatedSourceAttributionObject(queryString, storedValues) {
  var utmParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'sh_device',
    'sh_matchtype',
  ];
  var additiveValues = ['sh_ad1', 'sh_ad2', 'sh_ad3', 'sh_ad4'];
  var newValues = {};
  var wasUpdated = false;

  // Check if query string is not empty
  var queryStringkeys = Object.keys(queryString);
  if (queryStringkeys.length > 0) {
    var URLHasUTMParameters = arrayIntersects(queryStringkeys, utmParameters);
    var referrerCode = getReferrerCodeFromQS(queryString);
    wasUpdated = true;

    if (URLHasUTMParameters) {
      // Extract from the URL if present
      utmParameters.forEach(function (tag) {
        if (queryString[tag]) {
          newValues[tag] = queryString[tag];
        }
      });
    } else {
      // Extract from stored values if present
      utmParameters.forEach(function (tag) {
        if (storedValues[tag]) {
          newValues[tag] = storedValues[tag];
        }
      });
    }

    additiveValues.forEach(function (tag) {
      // If one of the additive values is present in the URL store it. If not fallback to stored values
      // If none of them are present, do nothing
      if (queryString[tag] || storedValues[tag]) {
        newValues[tag] = queryString[tag] || storedValues[tag];
      }
    });

    if (referrerCode) {
      newValues.attribution_snippet = referrerCode;
    } else if (storedValues.attribution_snippet) {
      newValues.attribution_snippet = storedValues.attribution_snippet;
    }
  } else {
    newValues = storedValues;
  }

  // Only store referrer if is not present
  if (!storedValues.http_referrer) {
    var referrerURL = document.referrer;

    if (referrerURL) {
      var parsedReferrerURL = parseURL(referrerURL);

      // Store referrer only if it's off-domain or on-domain but the subdomain is whitelisted
      if (
        isOffDomain(parsedReferrerURL.domain) ||
        (!isOffDomain(parsedReferrerURL.domain) &&
          SUBDOMAIN_WHITELIST.indexOf(parsedReferrerURL.subdomain) > -1)
      ) {
        newValues.http_referrer = referrerURL;
        wasUpdated = true;
      }
    }
  } else {
    newValues.http_referrer = storedValues.http_referrer;
  }

  return {
    newValues: newValues,
    wasUpdated: wasUpdated,
  };
}

function setAttributionCookie() {
  var queryString = getQueryString();
  var storedValue = getCookie(COOKIE_NAME);

  var results = getUpdatedSourceAttributionObject(queryString, storedValue);

  if (results.wasUpdated) {
    setCookie(COOKIE_NAME, encodeURIComponent(JSON.stringify(results.newValues)));
  }
}

setAttributionCookie();

export {
  setAttributionCookie,
  // Just for testing
  getQueryString,
  getCookie,
  arrayIntersects,
  getReferrerCodeFromQS,
  parseURL,
  isOffDomain,
  getUpdatedSourceAttributionObject,
  setCookie,
};
